var map = {
	"./views/About.vue": [
		"f820",
		"chunk-2d22d746"
	],
	"./views/GoodsList.vue": [
		"d2d3",
		"chunk-a2d020b2"
	],
	"./views/Home.vue": [
		"bb51"
	],
	"./views/applicationRefund.vue": [
		"b9ca",
		"chunk-1d1fba54"
	],
	"./views/batchManagement.vue": [
		"f565",
		"chunk-2dc1827a"
	],
	"./views/campusDetails.vue": [
		"388b",
		"chunk-23a198c6"
	],
	"./views/campusMicroStore.vue": [
		"6fb7",
		"chunk-26c57209"
	],
	"./views/detailsGoods.vue": [
		"4be3",
		"chunk-3d42d4ef"
	],
	"./views/fullBatch.vue": [
		"aeef",
		"chunk-05b7c8e6"
	],
	"./views/imagesLibrary.vue": [
		"4e12",
		"chunk-0d72e7a8"
	],
	"./views/inChargeManagement.vue": [
		"b477",
		"chunk-a089e82a"
	],
	"./views/login.vue": [
		"dd7b"
	],
	"./views/logisticsSetup.vue": [
		"1ac6",
		"chunk-e728863c"
	],
	"./views/menuManagement.vue": [
		"a281",
		"chunk-3629c0b6"
	],
	"./views/orderDetails.vue": [
		"3c06",
		"chunk-eef2df30"
	],
	"./views/orderInformation.vue": [
		"5bec",
		"chunk-9f939bd4"
	],
	"./views/roleManagement.vue": [
		"1b70",
		"chunk-6984fdcf"
	],
	"./views/salesStatistics.vue": [
		"0f16",
		"chunk-cd9c1b2a"
	],
	"./views/statisticalAnalysis.vue": [
		"429f",
		"chunk-49458985"
	],
	"./views/statisticalBatch.vue": [
		"e91b",
		"chunk-6b61d893"
	],
	"./views/statisticsBacthGoods.vue": [
		"69a9",
		"chunk-1c5badb1"
	],
	"./views/studentManagement.vue": [
		"b2b4",
		"chunk-242d100b"
	],
	"./views/userManagement.vue": [
		"f26b",
		"chunk-77338262"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "627e";
module.exports = webpackAsyncContext;